import { useState } from "react"
import { useNavigate } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"
import AsyncSelectField from "../../Shared/AsyncSelect"

const ZoneForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [villageOptions, setVillageOptions] = useState([])
    const [collectorOptions, setCollectorOptions] = useState([])

    const [formData, setFormData] = useState({
        name: "",
        village_id: "",
        collector_id: "",
    })
    const {name, village_id, collector_id} = formData

    const navigate = useNavigate()

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const zoneData = {name, village_id, collector_id}
        addZone(zoneData)
    }
    
    // add zone
    const addZone = async (zoneData) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/zones/', zoneData)
            if (response.status === 201){
                toast.success('Successfully created')
                navigate('/zones')
                setIsLoading(false)
            }else{
                toast.error(response.data?.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422){
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response?.data?.detail)
            }
        }
    }

    const loadOptions = async (url, query, setOptions) => {
        try {
            const response = await Server.get(`/options/${url}`, {
                params: { q: query },
            });
            setOptions(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    };

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Create New Zone</h3>
            </div>
            <div className="card-body">
            <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-4">
                            <InputField
                                placeholder="Zone Name"
                                name="name"
                                type="text"
                                label="Name"
                                value={name}
                                onChange={onChange}
                                error={errors.name}
                            />
                        </div>
                        <div className="col-md-4">
                            <AsyncSelectField
                                name="village_id"
                                label="Village"
                                value={village_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('villages', query, setVillageOptions)}
                                options={villageOptions}
                                placeholder="Start typing to search..."
                                error={errors.village_id}
                            />
                        </div>
                        <div className="col-md-4">
                            <AsyncSelectField
                                name="collector_id"
                                label="Collector"
                                value={collector_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('collectors', query, setCollectorOptions)}
                                options={collectorOptions}
                                placeholder="Start typing to search..."
                                error={errors.collector_id}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Save Zone" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default ZoneForm
